import React from 'react';
import { Dialog, DialogContent, Box, Typography, CircularProgress, styled } from '@mui/material';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 12,
    padding: theme.spacing(3),
    minWidth: 300,
    textAlign: 'center',
  },
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
}));

const SpinnerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

const LoadingSpinner = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export interface SavingModalProps {
  open: boolean;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
}

const SavingModal: React.FC<SavingModalProps> = ({ open, creating, updating, deleting }) => {
  const getOperationConfig = () => {
    if (creating) {
      return {
        title: 'Creating Preset',
        message: 'Please wait while we create your new preset...',
      };
    }

    if (updating) {
      return {
        title: 'Saving Changes',
        message: 'Please wait while we save your changes...',
      };
    }

    if (deleting) {
      return {
        title: 'Deleting Preset',
        message: 'Please wait while we delete the preset...',
      };
    }

    // Default fallback
    return {
      title: 'Processing',
      message: 'Please wait...',
    };
  };

  const config = getOperationConfig();

  return (
    <StyledDialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}} // Prevent closing during operations
      maxWidth="sm"
      fullWidth={false}
    >
      <DialogContent>
        <SpinnerContainer>
          <LoadingSpinner size={56} thickness={4} />
        </SpinnerContainer>

        <Typography variant="h6" fontWeight={600} gutterBottom>
          {config.title}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {config.message}
        </Typography>
      </DialogContent>
    </StyledDialog>
  );
};

export default SavingModal;
